import styled, { css } from 'styled-components';

import { Body } from '../../../components/BlueTheme/Table';
import { FOOTER_HEIGHT } from '../../../components/styled/PageWrapper/styled';

const DELAY_NOTIFICATION_HEIGHT = 52;

export const TemplateName = styled.div(
  ({ theme: { spacers } }) => css`
    padding-top: ${spacers!.spacer01};
    font-size: 36px;
    line-height: 42px;
    font-family: MultiplaneTWDC;
    font-weight: 600;
  `
);

export const ReportContainer = styled.div(
  ({ theme: { colors, spacers } }) => css`
    background-color: ${colors!.colorWhite};
    border-radius: ${spacers!.spacer02};
    margin-bottom: ${spacers!.spacer04};
  `
);

export const ReportInfo = styled.div`
  width: 75%;
  margin-right: ${({ theme: { spacers } }): string => `${spacers!.spacer07}`};
`;

export const PageWrapper = styled.div`
  height: calc(100% - ${FOOTER_HEIGHT}px);
`;

export const PageContent = styled.div<{ $notificationIsShowed?: boolean }>(
  ({ theme: { admanColors, spacers }, $notificationIsShowed }) => css`
    background: ${admanColors!.gray.light.fg[6]};
    padding: ${spacers!.spacer02} ${spacers!.spacer05} ${spacers!.spacer02} ${spacers!.spacer07};
    min-height: calc(100% - ${FOOTER_HEIGHT + ($notificationIsShowed ? DELAY_NOTIFICATION_HEIGHT : 0)}px);
    width: 100vw;
  `
);

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const BodyWrapper = styled(Body)(
  ({ theme: { spacers } }) => css`
    td {
      padding: 13px ${spacers!.spacer02};
    }
  `
) as typeof Body;

export const StyledPageWrapper = styled.div<{ $isMixedPath: boolean }>`
  width: 100%;
  display: block;
  min-height: ${({ $isMixedPath }): string => `calc(100vh - ${$isMixedPath ? 260 : 60}px) `};
`;
